import { createSlice } from '@reduxjs/toolkit';
import { ChartType } from '../../../infraestructure/types/chart.interface';

export type TFilterChart =
  | 'concentration_transactions'
  | 'balance_traceability'
  | 'yield_cost'
  | 'cash_flow'
  | 'g_last_transaction'
  | 'bank'
  | '';

interface UiState {
  isOpenSidebar: boolean;
  selectedFilters: {
    timeline: string | null;
    bank: string | null;
    account: string | null;
    chartType: ChartType | '';
  };
  dropdownVisibility: {
    timeline: boolean;
    bank: boolean;
    account: boolean;
  };
  filterState: {
    isOpenFilter: boolean;
    filterChart: TFilterChart;
  };
  isOpenChatAi: boolean;
}

const initialState: UiState = {
  isOpenSidebar: false,
  selectedFilters: {
    timeline: 'ult_12_months',
    bank: null,
    account: null,
    chartType: '',
  },
  dropdownVisibility: {
    timeline: true,
    bank: false,
    account: false,
  },
  filterState: {
    isOpenFilter: false,
    filterChart: '',
  },
  isOpenChatAi: false,
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    onToggleSidebar: (state) => {
      state.isOpenSidebar = !state.isOpenSidebar;
    },
    setFilter: (state, action) => {
      const { filterType, value, chartType } = action.payload;

      if (filterType === 'timeline') {
        state.selectedFilters.timeline = value;
        state.selectedFilters.bank = null;
        state.selectedFilters.account = null;
        state.selectedFilters.chartType = chartType;
      } else if (filterType === 'bank') {
        state.selectedFilters.bank = value;
        state.selectedFilters.timeline = null;
        state.selectedFilters.account = null;
        state.selectedFilters.chartType = chartType;
      } else if (filterType === 'account') {
        state.selectedFilters.account = value;
        state.selectedFilters.timeline = null;
        state.selectedFilters.bank = null;
        state.selectedFilters.chartType = chartType;
      }
    },
    toggleDropdownVisibility: (state, action) => {
      const { dropdownType } = action.payload;

      // Abrir el filtro si está cerrado; cerrarlo si está abierto
      Object.keys(state.dropdownVisibility).forEach((key) => {
        // Asegúrate de que solo el filtro actual esté abierto
        state.dropdownVisibility[key as keyof typeof state.dropdownVisibility] =
          key === dropdownType
            ? !state.dropdownVisibility[
                key as keyof typeof state.dropdownVisibility
              ]
            : false;
      });
    },
    showFilter: (state, action) => {
      const { dropdownType } = action.payload;

      if (dropdownType === 'timeline') {
        state.dropdownVisibility.timeline = true;
      } else if (dropdownType === 'bank') {
        state.dropdownVisibility.bank = true;
      } else if (dropdownType === 'account') {
        state.dropdownVisibility.account = true;
      }
    },
    setIsOpenFilter: (state, action) => {
      state.filterState.isOpenFilter = !state.filterState.isOpenFilter;
      state.filterState.filterChart = action.payload.typeChart;
    },
    setHiddenFilter: (state) => {
      state.filterState.isOpenFilter = false;
      state.filterState.filterChart = '';
    },
    setIsOpenChatAi: (state) => {
      state.isOpenChatAi = !state.isOpenChatAi;
    },
  },
});

export const {
  onToggleSidebar,
  setFilter,
  toggleDropdownVisibility,
  showFilter,
  setIsOpenFilter,
  setHiddenFilter,
  setIsOpenChatAi,
} = uiSlice.actions;
export default uiSlice.reducer;
